import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  NgZone,
  ChangeDetectorRef,
} from '@angular/core';
import Swiper, { SwiperOptions } from 'swiper';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Agenzia } from '../../../pages/store-locator-page/interfaces/agenzia.interface';
import {Networks} from "../../models/networks.enum";
import {Subject, Subscription} from "rxjs";
import {CmsService} from "../../../cms/services/cms.service";
import {environment} from '../../../../../environments/environment';
import { takeUntil } from 'rxjs/operators';
import { PrivacyService } from 'src/app/services/privacy.service';
import { getFormattedPrivacyTemplate } from 'src/app/modules/booking-flow/shared/utils/bkd.utils';
import { QuotationOperationInterface } from '../../interfaces/quotation-operation.interface';
import { UrlSites } from 'src/app/enums/url-sites.enum';

declare const MarkerClusterer;
@Component({
  selector: 'modal-select-agency',
  templateUrl: './modal-select-agency.component.html',
  styleUrls: ['./modal-select-agency.component.scss'],
})
export class ModalSelectAgencyComponent implements OnInit {
  @Input() storeList: Agenzia[];
  @Input() previouslySelectedStore: Agenzia;
  @Input() availableOperations: QuotationOperationInterface;
  @Output() storeSelected = new EventEmitter();

  //  Swiper config
  swiper: Swiper;
  index: number = 0;
  config: SwiperOptions = {
    spaceBetween: 16,
    breakpoints: {
      320: {
        slidesPerView: 1.1,
      },
      992: {
        slidesPerView: 2.2,
      },
    },
    simulateTouch: true,
    centeredSlides: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  //  Google Maps
  map: any;
  bounds: any;
  infowindow: google.maps.InfoWindow;
  geocoder: google.maps.Geocoder;
  markers: any[];

  //  Interazioni utente
  mapIsPristine: boolean = true;
  userSearchInput: string = null;
  unknownAddress: boolean = false;
  showWarningMessage: boolean = false;

  nearStores: any[];

  public brand: any;
  public isIstituzionale: boolean = false;
  public isPrivacyVisible = false;
  public networks = Networks;
  public privacyBodyText: string;
  
  private destroy$ = new Subject();
  private brandConfigSub: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    public ngZone: NgZone,
    public changeDetector: ChangeDetectorRef,
    private _cmsService: CmsService,
    private _privacyService: PrivacyService
  ) {}

  ngOnInit(): void {
    if (this.storeList?.length) {
      // filtro le agenzie/stores recuperando solo quelle che hanno "externalVisibility" a true --- solo in produzione, perché se non su pre non ne resta nemmeno una per le agenzie con le quali si testa
      this.storeList = this.storeList
        ?.filter((store) => {
          //TODO to remove environment.production
          return !environment.production || store.externalVisibility === true || store.externalVisibility === 'true' || store.externalVisibility === '1';
        });
      this.initialize();
    }

    this._cmsService.siteUrl$.pipe(takeUntil(this.destroy$)).subscribe((siteUrl) => {
      if (siteUrl) {
        if (siteUrl.includes(UrlSites.WTSTORE) || siteUrl.includes(UrlSites.WELCOMETRAVELSHOP) || siteUrl.includes(UrlSites.VACANZEWELCOMETRAVEL) || siteUrl.includes(UrlSites.GEOTN)) {
          this.isIstituzionale = true;
        }
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  initialize() {
    this.infowindow = new google.maps.InfoWindow();
    this.geocoder = new google.maps.Geocoder();
    window['angularComponentRef'] = { component: this, zone: this.ngZone };
    this.setMap();
    /* this.getUserPostion()
      .then((position: any) => {
        console.log("sono qui ", position)
        const { latitude, longitude } = position?.coords;
        if (latitude && longitude) {
          userPosition = {
            lat: latitude,
            lng: longitude,
          };
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        this.setMap(userPosition);
      }); */
  }

  //  Inizializzazione della mappa
  setMap(position = null) {
    if (!position) {
      position = {
        lat: 41.89,
        lng: 12.49,
      };
    }
    this.map = new google.maps.Map(document.getElementById('map'), {
      center: position,
      zoom: 9,
      disableDefaultUI: true,
      zoomControl: true,
    });

    this.setMarkers();

    //  Event Listener della mappa: al variare dei bounds (quando cambia la posizione della mappa)
    google.maps.event.addListener(this.map, 'bounds_changed', () => {
      this.unknownAddress = false;
      this.setNearStores();

      if (this.index >= this.nearStores?.length - 1) this.index = 0;

      //  La logica sottostante fa sì che se ad inizializzazione della mappa l'untente non...
      //  ...visualizza nemmeno un'agenzia, allora la posizione si modifica automaticamenre in modo da contenere tutti i markers
      if (!this.mapIsPristine) return;
      if (this.nearStores?.length) this.mapIsPristine = false;
      if (!this.nearStores?.length && this.mapIsPristine) {
        this.fitViewToMarkers();
      }
    });
  }

  //  Genera l'array degli stores nelle vicinanze (quelli attualmente visualizzati sulla mappa)
  setNearStores() {
    this.nearStores = [];
    this.bounds = this.map.getBounds();
    this.markers.forEach((marker) => {
      if (this.bounds && this.bounds.contains(marker.getPosition())) {
        this.nearStores.push(
          this.storeList.find((store) => marker.id === store.id)
        );
        this.changeDetector.detectChanges();
      }
    });
  }

  //  Trasforma la getCurrentPosition in Promise per agevolarne l'utilizzo
  getUserPostion() {
    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject)
    );
  }
  setMarkers() {
    this.brandConfigSub = this._cmsService.brandConfig$.subscribe(brand => {
      this.markers = [];
      this.storeList.forEach((store, index) => {
        if (store.latitude && store.longitude) {
          const marker = this.generateMarker(index, brand);
          this.markers.push(marker);
        }
      });
      let clusterIcon = '';

      if (brand?.networkId && brand.networkId == Networks.GEO) {
        clusterIcon = './assets/images/clusterer.svg';
      } else if (brand?.networkId && brand.networkId == Networks.WTG) {
        clusterIcon = './assets/images/clusterer-W.svg';
      }

      const clustererOptions = [
        {
          width: 100,
          height: 100,
          url: clusterIcon,
          textColor: '#FFF',
          textSize: 16,
          anchorText: [40, 0],
        },
      ];
      new MarkerClusterer(this.map, this.markers, {styles: clustererOptions});
    });
  }

  //  Genera un singolo marker
  generateMarker(storeIndex, brand: any = null) {
    const store = this.storeList[storeIndex];
    const { latitude, longitude } = store;
    const position = { lat: Number(latitude), lng: Number(longitude) };
    const popUpContent = this.getPopupContent(store);
    const icon = this.getIconMarkerOptions(brand);
    const markerOptions = {
      icon,
      position,
      map: this.map,
      animation: google.maps.Animation.DROP,
      id: store.id,
    };
    const marker = new google.maps.Marker(markerOptions);
    marker.addListener('click', () => {
      this.infowindow.setContent(popUpContent);
      this.infowindow.open(this.map, marker);
    });
    return marker;
  }

  //  Restituisce le opzioni per le icone dei markers
  getIconMarkerOptions(brand: any = null) {
    let pinIcon = '';

    if (brand?.networkId && brand.networkId == Networks.GEO) {
      pinIcon = './assets/images/smallG.png';
    } else if (brand?.networkId && brand.networkId == Networks.WTG) {
      pinIcon = './assets/images/smallW.png';
    }
    return {
      url: pinIcon,
      scaledSize: new google.maps.Size(47.75, 62.25),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 0),
    };
  }

  //  Ciò che avviene nel momento in cui l'utente seleziona uno store
  selectStore(storeId) {
    const selectedStore = this.storeList.find((store) => store.id === storeId);
    this.emitResult(selectedStore);
  }

  //  Chiude la modale passando come risultato lo store scelto dall'utente
  emitResult(result) {
    this.storeSelected.emit(result);
    this.activeModal.dismiss();
  }

  //  Tramite metodo fitBouds regola zoom e centro della mappa in modo da mostrare tutti i markers esistenti
  fitViewToMarkers() {
    const bounds = new google.maps.LatLngBounds();
    this.markers.forEach((marker) => {
      bounds.extend(marker.getPosition());
    });
    this.map.fitBounds(bounds);
  }

  //  Quando l'utente effettua una nuova ricerca per indirizzo
  onNewLocationSearch() {
    if (!this.userSearchInput?.trim()) return;
    this.geocoder.geocode(
      { address: this.userSearchInput },
      (results, status) => {
        if (!results?.[0]) {
          this.unknownAddress = true;
          return;
        }
        this.unknownAddress = false;
        if (!results?.[0]?.geometry?.location) return;
        let zoom;
        if (results?.[0]?.types.includes('route')) zoom = 18;
        if (results?.[0]?.types.includes('locality')) zoom = 12;
        this.navigateToLocation(results?.[0]?.geometry?.location, zoom);
      }
    );
  }

  //  Passato uno specifico store come parametro porta la mappa sulla sua posizione
  showStoreOnMap(store) {
    const location = {
      lat: Number(store.latitude),
      lng: Number(store.longitude),
    };
    this.navigateToLocation(location, 20);
  }

  //  Porta la mappa su una posizione e ne regola lo zoom
  navigateToLocation(location, zoom = 9) {
    this.map.setCenter(location);
    this.map.setZoom(zoom);
  }

  //  Genera html da mostrare come popUp al click su un marker
  getPopupContent(store) {
    return `
    <div class="agency agency--popup">
      <h3 class="agency__name">${store.denomination}</h3>
      <p class="agency__address">${store.address} - ${store.city} (${store.province})</p>
      <p class="agency__phone">tel: ${store.tel1}</p>
      <button class="agency__select btn btn--brand-color-03 w-100" onclick="window.angularComponentRef.zone.run(() => {window.angularComponentRef.component.selectStore(${store.id})})"};'>Scegli Questa Agenzia</button>
    </div>
      `;
  }

  public closeModal() {
    this.showWarningMessage = true;
  }
}
